export function Skeleton({
  width = "100%",
  height = "1rem",
  label = "Chargement",
}: {
  width?: string | number;
  height?: string | number;
  label?: string;
}) {
  return (
    <span className="nbs-skeleton" style={{ width, height }} role="status" aria-label={label} />
  );
}

export function SkeletonBlock({ lines = 3 }: { lines?: number }) {
  return (
    <div className="nbs-skeleton-block" aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} width={index === lines - 1 ? "60%" : "100%"} />
      ))}
    </div>
  );
}
